import { CardList, Typography } from '@maia/ui';
import { createFileRoute } from '@tanstack/react-router';
import { getTasksOptions } from '../../features/task/tasks/queryOptions';
import { OpenTaskWidget } from '../../features/shared/task/open-task-widget';
import { getInsurancesOptions } from '../../features/insurance/insurances/queryOptions';
import { getQuotationsOptions } from '../../features/quotation/quotations/queryOptions';
import { RecentlyClosedInsuranceCard } from '../../features/shared/insurance/recently-closed-insurance-card';
import { RecentlyMadeQuotationCard } from '../../features/shared/insurance/recently-made-quotation-card';
import { getSelf } from '../../features/broker/get-self/queryOptions';
import pageIndicator from 'nprogress';
import { useDrawerStore } from '../../stores/drawer.store';
import { TaskSidedrawer } from '../../features/shared/task/task-sidedrawer';
import { RefProvider } from '@maia/utils';

export const Route = createFileRoute('/_authenticated/dashboard')({
  component: Page,
  loader: async ({ context: { queryClient } }) => {
    const me = await queryClient.ensureQueryData(getSelf());
    pageIndicator.inc();

    const tasks = await queryClient.ensureQueryData(
      getTasksOptions({ page: 1, limit: 3, broker: me.guid }),
    );
    pageIndicator.inc();

    const insurances = await queryClient.ensureQueryData(
      getInsurancesOptions({
        page: 1,
        limit: 3,
        sort: 'createdAt,desc',
        status: 'active',
      }),
    );
    pageIndicator.inc();

    const quotations = await queryClient.ensureQueryData(
      getQuotationsOptions({
        page: 1,
        limit: 3,
        sort: 'createdAt,desc',
      }),
    );

    return {
      me: me,
      tasks: tasks.response,
      insurances: insurances.response,
      quotations: quotations.response,
    };
  },
});

function Page() {
  const { openDrawer } = useDrawerStore();
  const data = Route.useLoaderData();

  return (
    <RefProvider<HTMLDivElement>>
      {({ ref, trackedElement }) => (
        <div className="layout-simple relative" ref={ref}>
          <Typography
            variant="display4"
            weight="semibold"
            className="text-primaryMain area-page-header px-32 pt-40 pb-24"
          >
            Welkom terug <span className="text-secondaryMain">@</span>{' '}
            {data.me.firstName}!
          </Typography>

          <div className="area-page-content content-grid">
            <div className="col-span-full">
              <CardList
                title="Jouw taken"
                titleSize="body-l"
                items={data.tasks}
                resource="taken"
                render={(task) => (
                  <OpenTaskWidget
                    task={task}
                    onOpen={() => openDrawer({ type: 'task', data: task })}
                  />
                )}
              />
            </div>
            <div className="col-span-6">
              <CardList
                title="Recent afgesloten verzekeringen"
                titleSize="body-l"
                items={data.insurances}
                resource="recent afgesloten verzekeringen"
                render={(insurance) => (
                  <RecentlyClosedInsuranceCard insurance={insurance} />
                )}
              />
            </div>
            <div className="col-span-6">
              <CardList
                title="Recent gemaakte offertes"
                titleSize="body-l"
                items={data.quotations}
                resource="recent gemaakte offertes"
                render={(quotation) => (
                  <RecentlyMadeQuotationCard quotation={quotation} />
                )}
              />
            </div>
          </div>

          <TaskSidedrawer portalRef={trackedElement} />
        </div>
      )}
    </RefProvider>
  );
}
